import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const TradeTilesBand = styled(Box)({
  padding: '28px 0 4px',
  textAlign: 'left',
  '@media (max-width: 600px)': {
    padding: '22px 0 4px',
  },
});

export const BandTitle = styled('h2')({
  fontFamily: "'Plus Jakarta Sans', sans-serif",
  fontSize: '1.3rem',
  fontWeight: 700,
  letterSpacing: '-0.01em',
  color: '#1a1a2e',
  margin: '0 0 14px',
});
